import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { map, Observable, of, tap } from 'rxjs';
import { Locale } from '../../schemas/locale';
import { RequestsService } from './requests.service';
import { readItems } from '@directus/sdk';
import { HandleErrorsService } from './handle-errors.service';
import { City } from '../../schemas/cityLocale';
import { AccountsAppService } from '../../services/core/accounts-app.service';

@Injectable({
  providedIn: 'root',
})
export class CountryService {
  private requestsService = inject(RequestsService);
  private handleErrorsService = inject(HandleErrorsService);
  private accountsAppService = inject(AccountsAppService);
  private accountsAppInstance = this.accountsAppService.accountsAppInstance;

  public countries = signal<Locale[]>([]);
  public cities = signal<City[]>([]);

  constructor(private http: HttpClient) {
    // this.getFilteredCountries().subscribe();
    // this.getAllCountries()
  }

  setPrimaryCountry(country: Locale) {
    this.countries.set([country]);
    localStorage.setItem('country', JSON.stringify(country));
  }

  getPrimaryCountry(): Locale | null {
    const country = localStorage.getItem('country');
    return country ? JSON.parse(country) : null;
  }

  async getAllCountries(): Promise<Locale[]> {
    // console.log(this.countries());
    if (this.countries.length) {
      return this.countries();
    }

    try {
      const countries = await this.requestsService.handleRequest(() =>
        this.accountsAppInstance.request(
          readItems('country_locals', {
            filter: {
              is_active: {
                _eq: true,
              },
            },
            sort: 'sort',
            limit: -1,
          }),
        ),
      );

      this.countries.set(countries);
      return countries as Locale[];
    } catch (error) {
      this.handleErrorsService.handleErrors(error);

      return [];
    }

    // when Offline

    // return this.http
    //   .get<Locale[]>('/assets/data/locales.json')
    //   .pipe(tap((countries) => this.countries.set(countries)));
  }

  getCountry(code: string): Locale | undefined {
    return this.countries().find((country) => country.code === code);
  }

  // getFilteredCountry(code: string): Locale | undefined {
  //   return this.countries().find(
  //     (country) => country.code === code && (country.code === 'RW' || country.code === 'CM'),
  //   );
  // }

  async getCountryCitiesByCode(code: string): Promise<City[]> {
    try {
      const cities = await this.requestsService.handleRequest(() =>
        this.accountsAppInstance.request(
          readItems('city_locals', {
            filter: {
              country_code: {
                _eq: code,
              },
            },
            sort: 'sort',
            limit: -1,
          }),
        ),
      );

      this.cities.set(cities);
      return cities;
    } catch (error) {
      this.handleErrorsService.handleErrors(error);

      return [];
    }
  }
}
